import axios from '../axios';
//日志
export const getBasePriceLogPage = data => {
  return axios({
    url: '/api/sys/base/getBasePriceLogPage',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/api/moudules/editlog.js